import * as cookie from 'cookie';

export const getXsrfHeader = (): Record<string, string> => {
  const cookies = cookie.parse(document.cookie);
  const xsrfToken = cookies['XSRF-TOKEN'];
  return xsrfToken ? { 'X-XSRF-TOKEN': xsrfToken } : {};
};
